export default "__VITE_ASSET__BBtITDMk__"